import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

export const reduceInstallmentPlanTotalPriceBankTransferOperation = async (
  user: UserSummaryType,
  installmentPlanId: number,
  reduceAmount: number,
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const res = await appApi.reduceInstallmentPlanTotalPriceBankTransfer(
      user.id,
      installmentPlanId,
      reduceAmount,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    toast.success('הסכום הכולל הופחת בהצלחה');
    setLoading(false);
    onSuccess?.();
    return true;
  } catch (e) {
    console.error(
      'Error reducing bank transfer installment plan total price:',
      e,
    );
    toast.error('שגיאה בהפחתת הסכום הכולל');
    setLoading(false);
    return false;
  }
};
